import {
    MONUMPAY_WITHDRAWAL_REQUEST,
    MONUMPAY_WITHDRAWAL_REQUEST_SUCCESS,
    MONUMPAY_WITHDRAWAL_REQUEST_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
    loading: false,
    momunpay: null,
};

const monumpayWithdrawalRequestReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case MONUMPAY_WITHDRAWAL_REQUEST:
            return { ...state, loading: true };
        case MONUMPAY_WITHDRAWAL_REQUEST_SUCCESS:
            return {
                ...state,
                momunpay: action?.payload,
                loading: false,
            };
        case MONUMPAY_WITHDRAWAL_REQUEST_FAILURE:
            return { ...state, loading: false };
        default:
            return state;
    }
};

export default monumpayWithdrawalRequestReducer;
